const contentSquareID = 'content-square';
const contentSquareUxaID = 'content-square-uxa';

export const sendPageView = (path) => {
  window._uxa = window._uxa || [];
  window._uxa.push(['trackPageview', path]);
};

export const injectContentSquareScript = () => {
  try {
    if (document.getElementById(contentSquareID)) return;

    const script = document.createElement('script');
    script.id = contentSquareID;
    script.type = 'text/javascript';
    script.async = 'true';
    script.src = '/vm/static/content-square.js';
    document.getElementsByTagName('head')[0].appendChild(script);
  } catch (e) {
    console.error(e);
  }
};

export const removeContentSquareScript = () => {
  try {
    const script = document.getElementById(contentSquareID);
    document.head.removeChild(script);
    const scriptUxa = document.getElementById(contentSquareUxaID);
    document.head.removeChild(scriptUxa);

    window._uxa = undefined;
    window.CS_CONF = undefined;
  } catch (e) {
    console.error(e);
  }
};
